import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const errText = (d) => (typeof d === "string" ? d : Array.isArray(d) ? d.map((e) => e.msg).join(" ") : "Something went wrong");

export default function PersonalSignup() {
  const { personalSignup } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await personalSignup(f); navigate("/my"); } catch (x) { setErr(errText(x.response?.data?.detail)); } finally { setBusy(false); }
  };
  const fld = (k, label, type = "text") => <div><Label>{label}</Label><Input type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`signup-${k}`} required /></div>;
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <form onSubmit={submit} className="bg-white rounded-2xl shadow p-6 w-full max-w-sm space-y-4" data-testid="personal-signup-form">
        <div><h1 className="text-2xl font-bold text-slate-800">Create my CaterCTRL profile</h1>
          <p className="text-sm text-slate-500 mt-1">Your personal CaterCTRL account belongs to you — keep your schedule, availability, training and perks wherever you work.</p></div>
        {fld("name", "Full name")}{fld("email", "Email", "email")}{fld("password", "Password (min 8 characters)", "password")}
        {err && <p className="text-sm text-red-600" data-testid="signup-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-brand hover:bg-brand-hover" data-testid="signup-submit">Create profile</Button>
        <p className="text-xs text-slate-500 text-center">Setting up a business? <Link to="/login" className="text-brand">Sign in or register your business</Link></p>
      </form>
    </div>
  );
}
